import { createActionNamespace } from 'Modules/core/redux';

import { EmissionsReducer } from './types';


const emissionAction = createActionNamespace('emission');

export const emissionActions = {
    getEmissions: emissionAction<void>('GET_EMISSIONS'),
    setEmissionLoading: emissionAction<EmissionsReducer['isLoading']>('SET_EMISSION_LOADING'),
    setEmissionError: emissionAction<EmissionsReducer['error']>('SET_EMISSION_ERROR'),
    setEmissionItems: emissionAction<EmissionsReducer['data']>('SET_EMISSION_ITEMS'),
};
